import { useTheme } from '@fluentui/react';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { ReactNode } from 'react';

//the one width rule of the AI side pane, for every task type
export const taskAIPaneWidth: string = 'clamp(320px, 30%, 420px)';

interface ITaskAIPaneProps {
  children: ReactNode;
}

// The column that holds the AI assistant beside a task: a divider on its left, the shared width and its own scroll.
export const TaskAIPane = (props: ITaskAIPaneProps) => {
  const theme = useTheme();

  return (
    <IPStack.Item
      styles={{
        root: {
          width: taskAIPaneWidth,
          flexShrink: 0,
          minHeight: 0,
          overflowY: 'auto',
          borderLeft: `1px solid ${theme.palette.neutralLight}`,
          // the assistant's header, buttons, chat and input keep their distance from the divider
          paddingLeft: 10,
          boxSizing: 'border-box',
        },
      }}
    >
      {props.children}
    </IPStack.Item>
  );
};
